import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  // Frame
  hasUserSelector,
  // Navigation
  helpFooterSelector,
  xingCommunityFooterSelector,
  devBlogFooterSelector,
  // Props
  localeSelector,
  // App
  appsSelector,
} from '@xingternal/platform-layout-selectors';

const resourcesLinksSelector = createSelector(
  hasUserSelector,
  localeSelector,
  helpFooterSelector,
  xingCommunityFooterSelector,
  devBlogFooterSelector,
  appsSelector,
  (hasUser, locale, helpFooter, xingCommunityFooter, devBlogFooter, apps) => {
    return [helpFooter, xingCommunityFooter, devBlogFooter, !hasUser && apps]
      .filter(Boolean)
      .map(localizedLink(locale));
  }
);

export { resourcesLinksSelector };
